import {
  CREATE_CTI_CREDENTIAL,
  UPDATE_ALL_CTI_CREDENTIAL,
  DELETE_CTI_CREDENTIAL,
  GET_CTI_TICKET_FIELD,
  CREATE_CTI_TICKET,
  GET_ALL_CTI_CREDENTIAL,
} from "./index";

export const DeleteReduxDataCreateCti = () => {
  return (dispatch) => {
    dispatch({
      type: CREATE_CTI_CREDENTIAL,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataUpdateCti = () => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ALL_CTI_CREDENTIAL,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataDeleteCti = () => {
  return (dispatch) => {
    dispatch({
      type: DELETE_CTI_CREDENTIAL,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataTicketField = () => {
  return (dispatch) => {
    dispatch({
      type: GET_CTI_TICKET_FIELD,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataCreateTicket = () => {
  return (dispatch) => {
    dispatch({
      type: CREATE_CTI_TICKET,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataAllCtiCredential = () => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_CTI_CREDENTIAL,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

// ==================================== Delete Redux Data Service Users ======================================//
export const DeleteReduxDataCti = () => {
  return (dispatch) => {
    dispatch({
      type: DELETE_CTI_CREDENTIAL,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
    // dispatch({
    //   type: CREATE_CRM_CREDENTIAL,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: UPDATE_CRM_CREDENTIAL,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: CREATE_SIP_USER,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: UPDATE_SIP_USER,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: DELETE_SIP_USER,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: CREATE_TICKET_FIELD,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
    // dispatch({
    //   type: TEST_TICKET_FIELD,
    //   payload: {
    //     data: false,
    //     errorMessage: false,
    //   },
    // });
  };
};
// ==================================== End Delete Redux Data Service Users======================================//
